export default "/images/vendor/flag-icon-css/flags/4x3/fi.svg?3b522e7f272eee4009b2073b0b6735ac";